import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQuery } from "../api"
import {
  AdvisorSession,
  AdvisorSessionDetail,
  AdvisorSessionsResponse
} from "../../types"
import {
  ADVISOR_CONVERSATIONS_ENDPOINT,
  ADVISOR_CONVERSATION_DETAIL_ENDPOINT
} from "../../common/constants"

const reducerPath = "advisorApi"

export const advisorApi = createApi({
  reducerPath,
  baseQuery,
  endpoints: builder => ({
    getAdvisorSessions: builder.query<AdvisorSession[], void>({
      query: () => ADVISOR_CONVERSATIONS_ENDPOINT,
      transformResponse: (response: AdvisorSessionsResponse) =>
        response?.conversations?.filter(
          (item): item is AdvisorSession =>
            !!item && typeof item === "object" && "_id" in item
        ) ?? []
    }),
    getAdvisorSession: builder.query<AdvisorSessionDetail, string>({
      query: id => `${ADVISOR_CONVERSATION_DETAIL_ENDPOINT}/${id}`
    })
  })
})

export const { useGetAdvisorSessionsQuery, useGetAdvisorSessionQuery } =
  advisorApi
